import { render, staticRenderFns } from "./releasenotes.vue?vue&type=template&id=126fa44b&scoped=true&"
import script from "./releasenotes.vue?vue&type=script&lang=js&"
export * from "./releasenotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126fa44b",
  null
  
)

export default component.exports